$(document).ready(function () {
	/**
	 * Calc height of sticky CTA to adjust position
	 */
	let stickyCta = $('#buyNowSticky');

	if($(stickyCta).length) {
		function stickyCtaTopPos() {	
			let stickyCtaHeight = Math.floor($(stickyCta).outerHeight());
	
			document.documentElement.style.setProperty('--stickyCtaTopPos', stickyCtaHeight + 'px');

			// console.log(stickyCtaHeight);
		}

		stickyCtaTopPos();
	
		//- seTimeout for window resizing
		let resizeTimer;
	
		$(window).on('resize', function(e) {
			clearTimeout(resizeTimer);
	
			resizeTimer = setTimeout(function() {
				stickyCtaTopPos();
			}, 250);
	
		});
	}
		
	//salesBanner
	if ($('#salesBanner').length) {
		let salesBannerHeight = Math.floor($('#salesBanner').height());
		if ($('#salesBanner').hasClass('isStick')) {
			$('#salesBanner, .cta.btn:not(.param)').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top - salesBannerHeight
				}, 1000);
			});
		} else {
			$('#salesBanner, .cta.btn:not(.param)').on('click', function (event) {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top
				}, 1000);
			});
		}
	} else {
		//// Take to shooping cart ////
		$('.cta.btn:not(.param)').on('click', function (event) {
			if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
				$('html, body').animate({
					scrollTop: $("#promoBannerAnchor").offset().top
				}, 1200);
			} else {
				$('html, body').animate({
					scrollTop: $("#orderNow").offset().top
				}, 1200);
			}
		});
	}

	//video listener
	if ($('#topVSL').length > 0) {
		videojs('topVSL').ready(function () {
			this.on('timeupdate', function () {
				if (this.currentTime() >= (60 * 7)) {
					$('.videoWrapper .cta-wrap').addClass('show');
				}
				// console.log(this.currentTime());
			})
		});
	}

	(function () {
		//hamburger
		var hamburger = {
			navToggle: document.querySelector('.nav-toggle'),
			nav: document.getElementById('nav'),
			salesBanner: document.querySelector('.salesBanner'),

			doToggle: function (e) {
				e.preventDefault();
				this.navToggle.classList.toggle('expanded');
				this.nav.classList.toggle('expanded');
				this.salesBanner.classList.toggle('hide');
			}
		};

		if ($('#nav').length) {
			hamburger.navToggle.addEventListener('click', function (e) {
				hamburger.doToggle(e);
			});
		}
	}());

	//- Set current Year to footer Copyright
	let thisDate = new Date();
	$('#year').html(thisDate.getFullYear());
});

